export const defaultQueryParamsAllowList = {
    // Core Analytics & Attribution
    utm_campaign: true,
    utm_content: true,
    utm_device: true,
    utm_id: true,
    utm_matchtype: true,
    utm_medium: true,
    utm_placement: true,
    utm_source: true,
    utm_term: true,
    // Ad Platform Click IDs
    fbclid: true,
    gad_campaignid: true,
    gad_source: true,
    gbraid: true,
    gclid: true,
    msclkid: true,
    rdt_cid: true,
    // PartnerStack
    gspk: true,
    gsxid: true,
    // Checkout Studio
    originContext: true,
    uiMode: true,
    // Top used query params from Hubble
    account: true,
    action: true,
    active: true,
    amount: true,
    api_version: true,
    attemptId: true,
    autorun: true,
    backTo: true,
    campaign: true,
    channel: true,
    code_challenge_method: true,
    code_challenge: true,
    compare_to_end: true,
    compare_to_filter: true,
    compare_to_start: true,
    connected_accounts: true,
    contact: true,
    copy_to_live: true,
    country: true,
    create: true,
    created: true,
    currency: true,
    cursor: true,
    customer: true,
    dataset_id: true,
    date: true,
    destination: true,
    device_type: true,
    dispute: true,
    edit: true,
    email_id: true,
    enabled: true,
    endDate: true,
    ending_before_ts: true,
    ending_before: true,
    endpoint_location: true,
    eventId: true,
    eventType: true,
    experiment_id: true,
    experiment: true,
    feature: true,
    filtered: true,
    flow: true,
    force_login: true,
    from: true,
    fromWizard: true,
    id: true,
    iframe: true,
    in_flow: true,
    invoice: true,
    lang: true,
    language: true,
    lid: true,
    limit: true,
    linkType: true,
    livemode: true,
    locale: true,
    medium: true,
    merchant_name: true,
    mode: true,
    object: true,
    offset: true,
    order: true,
    org_name: true,
    page_number: true,
    page: true,
    past_due: true,
    payment_intent: true,
    payments: true,
    payout_option: true,
    platform: true,
    portalFlowType: true,
    previous: true,
    price: true,
    primary_filter: true,
    quantity: true,
    rate: true,
    read_filter: true,
    redirect_uri: true,
    redirect: true,
    ref: true,
    referer: true,
    remediate: true,
    response_type: true,
    returnToSearch: true,
    review: true,
    ruleId: true,
    schedule_phase_index: true,
    scope: true,
    search_context_id: true,
    section: true,
    selected_tab: true,
    selected: true,
    session_type: true,
    settingsRedirect: true,
    sort_direction: true,
    sort_field: true,
    sort: true,
    source: true,
    startDate: true,
    starting_after_ts: true,
    starting_after: true,
    state: true,
    status: true,
    step: true,
    stripe_landing: true,
    subscription_default_customer: true,
    subscription: true,
    switch: true,
    tab: true,
    teams: true,
    templateType: true,
    test: true,
    ticket_id: true,
    timezone: true,
    treatment: true,
    type: true,
    ui: true,
    unit: true,
    variant: true,
    version: true,
    view_id: true,
    view_type: true,
    view: true,
    visitor_type: true,
    year: true
};

//# sourceMappingURL=defaultQueryParamsAllowList.js.map